
    import Index from   "./_Index.vue"   
    import { Options, Vue } from "vue-class-component";   
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth'); 
    import {  Prop , Watch  } from 'vue-property-decorator';   

    @Options({
        name: "DisciplinaFalta",
        components: { Index   },  
    }) 
    export default class DisciplinaFalta extends Vue { 
        
        @Prop( ) readonly disciplina!: any

        @authStore.Getter
		public perfis!: any  

        public modal_cadastro ;
        
        created(){ 
            this.modal_cadastro = 'kt_cadatrar_disciplina_falta-agrupada';
		}  
    }
